<template>
  <!-- :card-item='cardItem' -->
  <list-view-page
    v-if='request.resourceId'
    title='Locations'
    :with-add='true'
    :request.sync='request'
    :list-item='addressListItem'
    :attrs="{withEdit: true, withDelete: true}"
    :touch='touch'
    @new='launchNewLocationWizard(spaceId)'
    @delete='deleteLocation'
    @hours='gotoHours'
    @edit='edit' >
    <!-- <w3w class='mx-10'
      :latitude='-26.1332759'
      :longitude='28.0692022' /> -->
  </list-view-page>

</template>

<script>
// import LocationEdit from './LocationEdit'
import ListViewPage from '@/components/layouts/ListViewPage.vue'
import AddressListItem from '@/components/listitems/AddressListItem.vue'
import LocationCard from '@/components/cards/LocationCard.vue'
// import w3w from '@/components/fields/w3w.vue'
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  name: 'LocationListPage',
  components: {
    ListViewPage,
    // w3w
    // LocationEdit
  },
  props: {
    spaceId: { required: true },
    // touch: { type: Number, default: 0 }
  },
  data () {
    return {
      items: [],
      newaddress: {},
      cardItem: LocationCard,
      addressListItem: AddressListItem,
      request: {
        resource: 'ag.spaces',
        extra: 'addresses',
        result: {}
      },
      touch: 1
    }
  },
  methods: {
    edit (location) {
      if (location && location.id) {
        let locationId = location.id
        this.launchLocationForm(this.spaceId, locationId)
      } else {
        window.alert('Unable to edit. No location specified')
      }
    },
    deleteLocation (location) {
      this.request.resourceId = this.spaceId
      this.request.extra = 'addresses/' + location.id
      this.$request('delete', this.request)
    },
    gotoHours (location) {
      let path = `/settings/spaces/${this.spaceId}/locations/${location.id}/hours`
      this.$router.push({path})
    },
    refresh () {
      this.touch++
      this.lookup()
    }
  },
  computed: {
    ...mapGetters('identity', ['getLocationsBySpaceId']),
    addresses () {
      if (this.spaceId) {
        return this.getLocationsBySpaceId(this.spaceId)
      }
      return []
      // return this.getObjectPath(this.requests, 'result.results', [])
    },
    requestStatus () {
      return this.request.status
    },
    touchId () {
      let locState = this.getObjectPath(this.$store.state.events, 'new-location-wizard.touch')
      let newLocState = this.getObjectPath(this.$store.state.events, 'location-form.touch')
      return locState + '/' + newLocState
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        Vue.set(this.request, 'resourceId', this.spaceId)
        this.refresh()
      }
    },
    touchId () {
      this.refresh()
    },
    requestStatus () {
      if (this.requestStatus === 204) {
        this.request.extra = 'addresses'
        this.refresh()
      }
      if (this.requestStatus === 200) {
        let payload = {
          key: 'locations',
          values: {}
        }
        let locations = this.getObjectPath(this.request, 'result.results', [])
        payload.values[this.spaceId] = locations
        this.$store.commit('identity/setLookup', payload)
      }
    }
  }
}
</script>
